import { TableCell, TableHead, TableRow, TableSortLabel, Checkbox, Tooltip } from "@material-ui/core"
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { permissionCheckFnforCamo } from "../../../../utils";
const EngModuleHd = ({ sortInfo, createSortHandler, bulk, toggleBulkOps, data, deleteallFn }) => {
	const tableSorting = (key, name) => {
		return <TableSortLabel active={sortInfo.sort === key ? true : false} direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler(key)} > {name}</TableSortLabel>
	}
	return (
		<TableHead className="fleet-ad-header engine-module-table">
			<TableRow>
				{!permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "D" }) || window?.location?.search.includes('archived-assets') || !data?.results?.length > 0  ? null :
					<TableCell style={{ minWidth: "150px" }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
							<Checkbox
								color="primary"
								size="small"
								onChange={(e) => toggleBulkOps(e.target.checked, 'bulk')}
								checked={data?.pagination?.total === bulk?.ids?.length && data?.pagination?.total > 0}
							/>
							{bulk?.ids?.length > 0 && (
								<Tooltip title="Delete" arrow placement="top">
									<span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}><DeleteOutlinedIcon color="secondary" onClick={deleteallFn} />({bulk?.ids?.length})</span>
								</Tooltip>
							)}
							Action(s)
						</div>
					</TableCell>}
				<TableCell style={{ minWidth: "140px" }}>{tableSorting('module_name', 'Engine Module')} </TableCell>
				<TableCell style={{ minWidth: "120px" }}>{tableSorting('section', 'Section')} </TableCell>
				<TableCell style={{ minWidth: "180px" }}>{tableSorting('description', 'Description')} </TableCell>
				<TableCell>{tableSorting('tsn', 'TSN')} </TableCell>
				<TableCell>{tableSorting('csn', 'CSN')} </TableCell>
				<TableCell>{tableSorting('tspr', 'TSPR')} </TableCell>
				<TableCell>{tableSorting('cspr', 'CSPR')} </TableCell>
				<TableCell style={{ minWidth: "180px" }}>{tableSorting('remarks', 'Remarks')} </TableCell>

			</TableRow>
		</TableHead>
	)
}
export default EngModuleHd